import { useLiveDate } from '../../hooks'
import { DateSpan } from './liveDate.styles'
import { LiveDateProps } from './liveDate.types'

const LiveDate = ({ startAt }: LiveDateProps) => {
  const liveDate = useLiveDate(startAt)

  if (!liveDate) return null

  return <DateSpan className="_d-block _text-1 _mb-1 _mt-4 _text-uppercase">{liveDate}</DateSpan>
}

export default LiveDate
